import PropTypes from 'prop-types';
import React, {Component} from 'react';

import classNames from 'classnames';

import CustomerContact from 'models/customerContact';

import {Input} from 'components/forms';
import {Button, Icon} from 'components/layout';
import {FormattedMessage} from 'react-intl';

class ContactCard extends Component {
  getContact = () => {
    if (this.props.deleted) {
      return undefined;
    }

    return new CustomerContact({
      nameFirst: this.firstName.getValue(),
      nameLast: this.lastName.getValue(),
      email: this.email.getValue(),
      homePhone: this.homePhone.getValue(),
      mobilePhone: this.mobilePhone.getValue(),
    });
  };

  render() {
    return <div className={classNames('contact-card', {'contact-card--outlined': this.props.outlined})}>
      {!this.props.deleted ? <div>
        <Input label={<FormattedMessage id='general.first.name'/>}
               required
               value={this.props.firstName}
               editMode={!this.props.readOnly}
               ref={fn => this.firstName = fn}
               group={this.props.group}/>
        <Input label={<FormattedMessage id='general.last.name' />}
               required
               value={this.props.lastName}
               editMode={!this.props.readOnly}
               ref={ln => this.lastName = ln}
               group={this.props.group}/>
        <Input label={<FormattedMessage id='general.email' />}
               value={this.props.email}
               editMode={!this.props.readOnly}
               ref={e => this.email = e}/>
        <Input label={<FormattedMessage id='general.primary.phone' />}
               value={this.props.homePhone}
               editMode={!this.props.readOnly}
               ref={hp => this.homePhone = hp}/>
        <Input label={<FormattedMessage id='general.alternate.phone' />}
               value={this.props.alternatePhone}
               editMode={!this.props.readOnly}
               ref={mp => this.mobilePhone = mp}/>

        {this.props.delete ? <Button icon
                                     onClick={this.props.delete}
                                     className='contact-card__delete'><Icon name='trash'/></Button> : null}
        <div className='clearfix'/>
      </div> : '(deleted)'}
    </div>;
  }
}

ContactCard.propTypes = {
  alternatePhone: PropTypes.string,
  delete: PropTypes.func,
  deleted: PropTypes.bool,
  email: PropTypes.string,
  firstName: PropTypes.string,
  group: PropTypes.object,
  homePhone: PropTypes.string,
  lastName: PropTypes.string,
  outlined: PropTypes.bool,
  readOnly: PropTypes.bool,
};
ContactCard.defaultProps = {
  deleted: false,
  outlined: false,
};

export default ContactCard;
